import request from '../utils/axios/request';
import { IMaintenance } from './Maintenance.service';

interface Monitoring {
	created_at: string;
	observation: string;
	problems: number[] | null;
}

export interface ReportContainerData {
	container_label: string;
	monitoring: Monitoring[];
	container_temperature: number;
	monitoring_am_count: number;
	monitoring_pm_count: number;
}

export interface MonitoringReport {
	travel_code: string;
	containers: ReportContainerData[];
}

export interface ContainerMonitor {
	date: Date;
	date_in: Date;
	date_out: Date;
	ship: string;
	travel: string;
	setpoint: string;
	temperature: string;
	supply?: number | string | null;
	return?: number | string | null;
	owner: string;
	position: string;
	errors: number[];
	images: string[];
}

export interface MonitorReport {
	shipStats: ShipStats[];
	data: ContainerReportProps[];
}

export interface ContainerReportProps {
	label: string;
	carrier?: string | null;
	date_begin: Date;
	date_end: Date;
	monitors: ContainerMonitor[];
	accountId: string;
}

export interface FinancialReportProps {
	monitoringValue: number;
	maintenanceValue: number;
	chartData: {
		date: string;
		monitorings: number;
		maintenances: number;
		totalMateriais: number;
	}[];
}

export interface MonitoringFiltersProps {
	idClient?: number;
	startDate?: Date;
	endDate?: Date;
	clientEmail?: string;
	ship?: string;
	container?: string;
	travelCode?: string;
	yard?: string;
}

export interface MaintenanceReport extends IMaintenance {
	totalMat: number;
	totalLabor: number;
}

interface QueryMaintenance {
	yard: string;
	accountId: string;
	dateBegin: Date;
	dateEnd: Date;
}

export interface ShipStats {
	ship: string;
	travelCode: string;
	containers: string[];
	monitoringTotal: number;
	price: number;
}

abstract class ReportsService {
	static async dailyMonitoringReports(
		idYard: number,
		date: Date
	): Promise<MonitoringReport[] | undefined> {
		try {
			const response = await request(
				`/reports/monitoring/yard/${idYard}/daily`,
				'get',
				{
					params: {
						date,
					},
				}
			);
			return response as MonitoringReport[];
		} catch (error) {}
	}

	static async filteredReports({
		idClient,
		clientEmail,
		ship,
		container,
		travelCode,
		startDate,
		endDate,
		yard,
	}: MonitoringFiltersProps): Promise<MonitorReport | undefined> {
		try {
			const response = await request(`/reports/monitoring`, 'get', {
				params: {
					idClient,
					clientEmail,
					ship,
					container,
					travelCode,
					startDate,
					endDate,
					yard,
				},
			});
			return response as MonitorReport;
		} catch (error) {}
	}

	static async financialReports(
		clientId: number,
		initialDate: Date,
		finalDate: Date
	): Promise<FinancialReportProps | undefined> {
		try {
			const response = await request(
				`/reports/financial/${clientId}`,
				'get',
				{
					params: {
						initialDate,
						finalDate,
					},
				}
			);
			return response as FinancialReportProps;
		} catch (error) {}
	}

	static async getAllMaintenances({
		yard,
		accountId,
		dateBegin,
		dateEnd,
	}: QueryMaintenance) {
		try {
			const response = await request('/reports/maintenance', 'get', {
				params: {
					yard,
					clientId: accountId,
					dateBegin: dateBegin.toISOString(),
					dateEnd: dateEnd.toISOString(),
				},
			});
			return response as MaintenanceReport[];
		} catch (error) {
			console.error(error);
		}
	}
}

export default ReportsService;
